<template>
  <div
    class="owal-row-accessory__icon"
  >
    <i class="chevron right small icon" />
  </div>
</template>

<script>
import { OwalListRowAccessoryType } from '../model/OwalListRowAccessoryType'
export { OwalListRowAccessoryType }
export default {
  name: 'OwalListRowAccessory',
  props: {
    type: Number,
    default () {
      return OwalListRowAccessoryType.NONE
    },
  },
}
</script>

<style scoped>
.owal-row-accessory__icon,
.owal-row-accessory__icon i
{
  display: flex;
  align-items: center;
  align-content: center;
  flex-shrink: 0;
  justify-content: center;
  overflow: hidden;
  height: 100%;
}
</style>
